import React, { Component } from "react";
import "../css/orderComplete.css";
import CompleteItem from './CompleteItem';

import ReactGA from 'react-ga';

class OrderComplete extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cartItems: []
        }
    }

    render() {
        return (
            <div className="orderCompleteHolder">
                <div className="orderCompleteInner">
                    <div className="headerText">Success!</div>
                    <div style={{ height: "85px", width: "85px", marginTop: "10px", marginLeft: "auto", marginRight: "auto" }}>
                        <img src={require('../images/check.png')} style={{ height: "85px", width: "85px" }} />
                    </div>
                    <div style={{ width: 90 + "%", marginRight: "auto", marginLeft: "auto" }}>
                        <div className="smallerText">Thank you for shopping with HousePlanStore.com. Your order is on it's way.</div>
                        <div className="smallerText">Order No. <strong>{localStorage.getItem('orderId')}</strong></div>
                    </div>
                    <div style={{ width: 90 + "%", marginRight: "auto", marginLeft: "auto" }}>
                        <div className="smallerText">A receipt for this transaction has been sent to your email address.</div>
                    </div>

                    {this.state.cartItems}

                    <div style={{ width: 90 + "%", marginRight: "auto", marginLeft: "auto" }}>
                        <div className="smallerText">If you have any questions about your order, please call <br /><a style={{ textDecoration: "none", color: "#0098c5", fontSize: "25px" }} href="tel:2519786088" data-rel="external">251-978-6088</a> <br />(Mon-Fri 9AM-5PM CST)</div>
                        <br /><br />
                    </div>

                    {/* <div style={{ marginTop: "10px", textAlign: "center" }} >
                        <a onClick={() => { this.closeOverlay() }} style={{ fontFamily: 'EB Garamond', color: "#0098c5", fontSize: "24px" }} href="/webapp">Return Home</a>
                        <br /><br />
                    </div> */}
                </div>
            </div>
        )
    }

    getCartItems = () => {
        if (localStorage.getItem('cart') !== null) {
            //console.log(localStorage.getItem('cart'))
            var body = new FormData();
            body.append('cartContents', localStorage.getItem('cart'));
            var url = "https://www.houseplanstore.com/web_api/?v=getCartContents";
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url, true);
            xhr.onload = function (e) {
                try {
                    //console.log(xhr.responseText)
                    var json = JSON.parse(xhr.responseText);
                    var array = [];
                    for (var i = 0; i < Object.keys(json[0]).length; i++) {
                        //pass in the refreshSubtotal function so when an item is deleted, it's price gets removed from the total
                        array.push(<CompleteItem refreshSubtotal={this.refreshSubtotal} key={i} item={json[0][i]} />);
                    }
                    array.reverse();
                    this.setState({
                        cartItems: [...this.state.cartItems, ...array],
                        subtotal: (parseInt(json[1]) * 100)
                    });
                    console.log("subtotal", this.state.subtotal);
                    localStorage.removeItem('cart');
                } catch (err) {
                    console.log(err);
                }
            }.bind(this);
            xhr.send(body);
        }
    }

    closeOverlay = () => {
        var closeOverlay = this.props.closeOverlay;
        closeOverlay();
    }

    componentDidMount() {
        if (localStorage.getItem('cart') !== null) {
            ReactGA.pageview('/webapp/order_complete/');
            var total = localStorage.getItem('total');
            ReactGA.event({
                category: 'User',
                action: 'Completed Checkout',
                label: total
            });
            localStorage.removeItem('total');
            this.getCartItems();
        } else{
            window.location.href = 'https://www.houseplanstore.com';
        }
    }
}

export default OrderComplete;